// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/check-white.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectionBlock_payment-block__DuJ-H {
  background: #ffffff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #6b7280;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04);
  margin-top: 10px;
  font-weight: 300;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_payment-header__5hzlX {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_select-all__Eutgg {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_select-all-text__XRL7B {
  font-weight: 600;
  font-size: 14px;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 .selectionBlock_service-row__VIl5A {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #ddd;
  transition: background 0.12s;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 .selectionBlock_service-row__VIl5A:hover {
  background: #fbfdff;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 .selectionBlock_service-row__VIl5A .selectionBlock_service-left__ZeYnr {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 .selectionBlock_service-row__VIl5A .selectionBlock_service-left__ZeYnr input[type=checkbox] {
  width: 18px;
  height: 18px;
  accent-color: #666 !important;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 .selectionBlock_service-row__VIl5A .selectionBlock_service-info__szZ-e {
  display: flex;
  flex-direction: column;
  line-height: 1;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 .selectionBlock_service-row__VIl5A .selectionBlock_service-info__szZ-e .selectionBlock_service-sub__cZ1hC {
  font-size: 10px;
  color: #6b7280;
  margin-bottom: 4px;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 .selectionBlock_service-row__VIl5A .selectionBlock_service-price__yZqTV {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  color: #0f172a;
  min-width: 90px;
  text-align: right;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 .selectionBlock_service-row__VIl5A .selectionBlock_service-price__yZqTV .selectionBlock_price-dollars__UzNL9 {
  font-size: 14px;
  color: #2e7d32;
  margin-right: 2px;
  line-height: 1;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_services-list__\\+1\\+47 .selectionBlock_service-row__VIl5A .selectionBlock_service-price__yZqTV .selectionBlock_price-cents__qNGTt {
  font-size: 14px;
  color: #2e7d32;
  position: relative;
  top: -4px;
  line-height: 1;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_note__C8NeF {
  font-size: 14px;
  color: #666;
  text-align: right;
  margin-bottom: 4px;
  white-space: normal !important;
  word-break: normal !important;
  overflow-wrap: break-word !important;
  font-size: 10px !important;
  margin-right: 0px !important;
  display: flex;
  justify-content: end !important;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_note__C8NeF .selectionBlock_text__wSxG5 {
  max-width: 190px !important;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_total__NaWL5 {
  font-weight: bold;
  color: #2e7d32;
  font-size: 16px;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_total-row__NQp3S {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_total-row__NQp3S .selectionBlock_total-label__YNN3C {
  color: #374151;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_total-row__NQp3S .selectionBlock_total-value__BlRJJ {
  color: #666 !important;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_success-block__p0iN3 {
  margin-top: 24px;
  padding: 16px;
  border: 1px solid #d1fae5;
  background-color: #ecfdf5;
  border-radius: 8px;
  text-align: center;
  color: #065f46;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_success-block__p0iN3 .selectionBlock_success-title__XGqdZ {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #059669;
}
.selectionBlock_payment-block__DuJ-H .selectionBlock_success-block__p0iN3 .selectionBlock_success-checkmark__ZvKin {
  font-size: 32px;
  color: #059669;
  margin-bottom: 12px;
}

.selectionBlock_success-block__p0iN3 {
  background: #f0fff4;
  border: 2px solid #38a169;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  max-width: 500px;
  margin: 2rem auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.selectionBlock_success-block__p0iN3 .selectionBlock_success-title__XGqdZ {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2f855a;
  margin-bottom: 1rem;
}
.selectionBlock_success-block__p0iN3 .selectionBlock_success-checkmark__ZvKin {
  font-size: 3rem;
  color: #38a169;
  margin: 1rem 0;
  animation: selectionBlock_pop__xgVpH 0.4s ease-in-out;
}
.selectionBlock_success-block__p0iN3 p {
  font-size: 1rem;
  color: #2d3748;
  margin: 0.5rem 0;
}
.selectionBlock_success-block__p0iN3 p strong {
  color: #2f855a;
}

@keyframes selectionBlock_pop__xgVpH {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  80% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}
.selectionBlock_plan-summary__OwGVc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
  font-size: 16px;
  color: #333;
}
.selectionBlock_plan-summary__OwGVc .selectionBlock_plan-name__LqtRO {
  font-weight: 600;
}
.selectionBlock_plan-summary__OwGVc .selectionBlock_payment-method__qbkWV {
  font-weight: 500;
}
.selectionBlock_plan-summary__OwGVc .selectionBlock_payment-method__qbkWV strong {
  font-weight: 700;
}
.selectionBlock_plan-summary__OwGVc .selectionBlock_payment-method__qbkWV span {
  margin-left: 4px;
  color: #666;
}

.selectionBlock_row__D-zEZ {
  width: 100%;
  display: flex;
  justify-content: center;
}

.selectionBlock_col__tF-gw {
  width: 100%;
  max-width: 980px;
  padding: 0 1rem;
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

/* Button base */
.selectionBlock_btn__4klLT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.selectionBlock_btnLarge__cNftO {
  font-size: 1.125rem;
  padding: 1.25rem 2rem;
}

.selectionBlock_btn__4klLT:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.12);
  transform: translateY(-1px);
}

/* Gray link-like button */
.selectionBlock_btnGray__2P3e1 {
  background-color: #e6e6e6;
  color: #222;
  box-shadow: none;
}
.selectionBlock_btnGray__2P3e1:hover {
  filter: brightness(0.98);
}
.selectionBlock_btnGray__2P3e1:active {
  transform: translateY(0);
}

/* Orange primary button */
.selectionBlock_btnOrange__5CjDe {
  background-color: #ff8a00;
  color: #fff;
  box-shadow: 0 6px 18px rgba(255, 138, 0, 0.18);
}
.selectionBlock_btnOrange__5CjDe:hover {
  filter: brightness(0.97);
}
.selectionBlock_btnOrange__5CjDe:active {
  transform: translateY(1px);
}

.selectionBlock_printBtn__V3K4f {
  order: 2;
}

/* Responsive */
@media (max-width: 640px) {
  .selectionBlock_col__tF-gw {
    justify-content: center;
    gap: 0.5rem;
  }
  .selectionBlock_btnLarge__cNftO {
    width: 100%;
    padding: 0.9rem 1rem;
    font-size: 1rem;
  }
  .selectionBlock_printBtn__V3K4f {
    order: 1;
  }
}
.selectionBlock_mb-20__Vw3iq {
  margin-bottom: 20px !important;
}

.selectionBlock_mr-10__R424\\+ {
  margin-right: 10px !important;
}

input[type=checkbox]:checked {
  border-radius: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #666 !important;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 60%;
}

input[type=checkbox]:checked {
  border-radius: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #666 !important;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 60%;
}

input[type=checkbox] {
  width: 20px;
  height: 20px;
  border: 1px solid #666;
  background-position: 50%;
  background-size: 20px auto;
  -webkit-appearance: none;
}

.selectionBlock_mr-10__R424\\+ {
  margin-right: 10px !important;
}

.selectionBlock_mr-10__R424\\+ {
  margin-right: 10px !important;
}

.selectionBlock_select-all-check__IO7aN, .selectionBlock_select-all-radio__p6N71 {
  height: 25px !important;
  min-height: 0 !important;
  width: 25px !important;
}

.selectionBlock_g-font-size-20__cc5yY, .selectionBlock_gfs-20__hWdwo {
  font-size: 20px !important;
}

.selectionBlock_g-font-weight-300__V3dcW, .selectionBlock_gfw-3__5A82z {
  font-weight: 300 !important;
}

.selectionBlock_m-0__ReH-G {
  margin: 0 !important;
}

.selectionBlock_g-font-size-20__cc5yY, .selectionBlock_gfs-20__hWdwo {
  font-size: 20px !important;
}

.selectionBlock_g-font-weight-300__V3dcW, .selectionBlock_gfw-3__5A82z {
  font-weight: 300 !important;
}

.selectionBlock_tru-mma-main-add__-a2gZ, .selectionBlock_tru-mma-main-content-box__HeYxx, .selectionBlock_tru-mma-main-service-box__JuPBB {
  border: 1px solid #6c757d;
}

@media (max-width: 768px) {
  .selectionBlock_tru-mma-main-content-box__HeYxx {
    border: 0;
    padding: 0 20px !important;
  }
}
@media (min-width: 768px) {
  .selectionBlock_mb-md-0__czojD {
    margin-bottom: 0 !important;
  }
}
.selectionBlock_border-bottom__fuNPv {
  border-bottom: 1px solid #6c757d !important;
}

.selectionBlock_p-30__hoZvg {
  padding: 30px !important;
}

.selectionBlock_g-font-weight-300__V3dcW, .selectionBlock_gfw-3__5A82z {
  font-weight: 300 !important;
}

@media (min-width: 768px) {
  .selectionBlock_text-md-left__iTsVt {
    text-align: left !important;
  }
}
@media (min-width: 768px) {
  .selectionBlock_tru-mma-main-content-box__HeYxx .selectionBlock_tru-mma-main-side__1DO1v {
    border-left: 1px solid #6c757d !important;
  }
}
@media (min-width: 992px) {
  .selectionBlock_text-lg-left__V3J9s {
    text-align: left !important;
  }
}
.selectionBlock_bg-white__9l9H\\+ {
  background-color: #fff !important;
}

.selectionBlock_p-10__TJJiY {
  padding: 10px !important;
}

@media (min-width: 992px) {
  .selectionBlock_g-font-size-lg-16__cRpaw, .selectionBlock_gfs-lg-16__Y56Th {
    font-size: 16px !important;
  }
}
.selectionBlock_g-font-size-14__jYEd1, .selectionBlock_gfs-14__BMBv0 {
  font-size: 14px !important;
}

@media (min-width: 992px) {
  .selectionBlock_g-font-size-lg-16__cRpaw, .selectionBlock_gfs-lg-16__Y56Th {
    font-size: 16px !important;
  }
}
.selectionBlock_g-font-size-14__jYEd1, .selectionBlock_gfs-14__BMBv0 {
  font-size: 14px;
}

@media (min-width: 768px) {
  .selectionBlock_g-font-size-md-40__z3WNL, .selectionBlock_gfs-md-40__nI0x8 {
    font-size: 40px !important;
  }
}
.selectionBlock_g-font-size-50__SIzf4, .selectionBlock_gfs-50__zp\\+Vq {
  font-size: 50px !important;
}

.selectionBlock_g-font-weight-700__uOkFD, .selectionBlock_gfw-7__b6hk\\+ {
  font-weight: 700 !important;
}

.selectionBlock_g-line-height-1_2__X\\+sMq, .selectionBlock_glh-1_2__IirWd {
  line-height: 1.2 !important;
}

.selectionBlock_text-green__lDYKZ {
  color: #73c573 !important;
}

.selectionBlock_g-font-weight-700__uOkFD, .selectionBlock_gfw-7__b6hk\\+ {
  font-weight: 700 !important;
}

.selectionBlock_g-line-height-1_2__X\\+sMq, .selectionBlock_glh-1_2__IirWd {
  line-height: 1.2 !important;
}

.selectionBlock_text-green__lDYKZ {
  color: #73c573 !important;
}

@media (min-width: 768px) {
  .selectionBlock_g-font-size-md-40__z3WNL, .selectionBlock_gfs-md-40__nI0x8 {
    font-size: 40px !important;
  }
}
@media (min-width: 768px) {
  .selectionBlock_g-font-size-md-22__4G2X2, .selectionBlock_gfs-md-22__S2E0m {
    font-size: 22px !important;
  }
}
sup {
  top: -0.5em;
}

.selectionBlock_m-0__ReH-G {
  margin: 0 !important;
}

.selectionBlock_g-font-size-24__tmwC-, .selectionBlock_gfs-24__89tHS {
  font-size: 24px !important;
}

.selectionBlock_g-font-weight-300__V3dcW, .selectionBlock_gfw-3__5A82z {
  font-weight: 300 !important;
}

.selectionBlock_g-line-height-1__dGrFX, .selectionBlock_glh-1__2cZ0F {
  line-height: 1 !important;
}

.selectionBlock_bg-white__9l9H\\+ {
  color: #666;
  font-weight: 300;
}

.selectionBlock_g-font-size-12__gBOOx, .selectionBlock_gfs-12__db-Qk {
  font-size: 12px !important;
}

.selectionBlock_g-line-height-1_2__X\\+sMq, .selectionBlock_glh-1_2__IirWd {
  line-height: 1.2 !important;
}

.selectionBlock_g-font-weight-300__V3dcW, .selectionBlock_gfw-3__5A82z {
  font-weight: 300 !important;
}

.selectionBlock_g-font-size-26__cVeZE, .selectionBlock_gfs-26__d93Xj {
  font-size: 26px !important;
}

.selectionBlock_tg-ml-6__cVWDF {
  margin-left: 6 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/selectionBlock.module.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,yFAAA;EAEA,cAAA;EACA,4CAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AADR;AAII;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAFR;AAKQ;EACI,gBAAA;EACA,eAAA;AAHZ;AAOI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AALR;AAOQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;AALZ;AAOY;EACI,mBAAA;AALhB;AAQY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AANhB;AAQgB;EACI,WAAA;EACA,YAAA;EACA,6BAAA;AANpB;AAUY;EACI,aAAA;EACA,sBAAA;EACA,cAAA;AARhB;AAUgB;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AARpB;AAYY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAVhB;AAYgB;EACI,eAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AAVpB;AAagB;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AAXpB;AAkBI;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EACA,0BAAA;EACA,4BAAA;EACA,aAAA;EACA,+BAAA;AAhBR;AAkBQ;EACI,2BAAA;AAhBZ;AAoBI;EACI,iBAAA;EACA,cAAA;EACA,eAAA;AAlBR;AAqBI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAnBR;AAqBQ;EACI,cAAA;AAnBZ;AAsBQ;EACI,sBAAA;AApBZ;AAyBI;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAvBR;AAyBQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAvBZ;AA0BQ;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AAxBZ;;AA6BA;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AA1BJ;AA4BI;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA1BR;AA6BI;EACI,eAAA;EACA,cAAA;EACA,cAAA;EACA,qDAAA;AA3BR;AA8BI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AA5BR;AA8BQ;EACI,cAAA;AA5BZ;;AAkCA;EACI;IACI,qBAAA;IACA,UAAA;EA/BN;EAkCE;IACI,qBAAA;IACA,UAAA;EAhCN;EAmCE;IACI,mBAAA;EAjCN;AACF;AAoCA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAlCJ;AAoCI;EACI,gBAAA;AAlCR;AAqCI;EACI,gBAAA;AAnCR;AAqCQ;EACI,gBAAA;AAnCZ;AAsCQ;EACI,gBAAA;EACA,WAAA;AApCZ;;AAsDA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AAnDJ;;AAsDA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;EACA,SAnBE;EAoBF,mBAAA;EACA,eAAA;AAnDJ;;AAsDA,gBAAA;AACA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAlCK;EAmCL,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,uDAAA;EACA,yBAAA;UAAA,iBAAA;EACA,wCAAA;AAnDJ;;AAsDA;EACI,mBA3CW;EA4CX,qBAAA;AAnDJ;;AAsDA;EACI,aAAA;EACA,6CAzCY;EA0CZ,2BAAA;AAnDJ;;AAsDA,0BAAA;AACA;EACI,yBAnDM;EAoDN,WAnDQ;EAoDR,gBAAA;AAnDJ;AAqDI;EACI,wBAAA;AAnDR;AAsDI;EACI,wBAAA;AApDR;;AAwDA,0BAAA;AACA;EACI,yBAhEQ;EAiER,WAhEU;EAiEV,8CAAA;AArDJ;AAuDI;EACI,wBAAA;AArDR;AAwDI;EACI,0BAAA;AAtDR;;AA0DA;EACI,QAAA;AAvDJ;;AA0DA,eAAA;AACA;EACI;IACI,uBAAA;IACA,WAAA;EAvDN;EA0DE;IACI,WAAA;IACA,oBAAA;IACA,eAAA;EAxDN;EA2DE;IACI,QAAA;EAzDN;AACF;AA+DA;EACI,8BAAA;AA7DJ;;AA+DA;EACI,6BAAA;AA5DJ;;AA8DA;EACI,gBAAA;EACA,yDAAA;EACA,iCAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA;AA3DJ;;AA6DA;EACI,gBAAA;EACA,yDAAA;EACA,iCAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA;AA1DJ;;AA4DA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,wBAAA;AAzDJ;;AA2DA;EACI,6BAAA;AAxDJ;;AA0DA;EACI,6BAAA;AAvDJ;;AAyDA;EACI,uBAAA;EACA,wBAAA;EACA,sBAAA;AAtDJ;;AAyDA;EACI,0BAAA;AAtDJ;;AAwDA;EACI,2BAAA;AArDJ;;AAuDA;EACI,oBAAA;AApDJ;;AAsDA;EACI,0BAAA;AAnDJ;;AAqDA;EACI,2BAAA;AAlDJ;;AAoDC;EACG,yBAAA;AAjDJ;;AAmDA;EACI;IACI,SAAA;IACA,0BAAA;EAhDN;AACF;AAkDA;EACI;IACI,2BAAA;EAhDN;AACF;AAkDA;EACI,2CAAA;AAhDJ;;AAkDA;EACI,wBAAA;AA/CJ;;AAiDA;EACI,2BAAA;AA9CJ;;AAgDA;EACI;IACI,2BAAA;EA7CN;AACF;AA+CA;EACI;IACI,yCAAA;EA7CN;AACF;AA+CA;EACI;IACI,2BAAA;EA7CN;AACF;AA+CA;EACI,iCAAA;AA7CJ;;AA+CA;EACI,wBAAA;AA5CJ;;AA8CA;EACI;IACI,0BAAA;EA3CN;AACF;AA6CA;EACI,0BAAA;AA3CJ;;AA6CA;EACI;IACI,0BAAA;EA1CN;AACF;AA4CA;EACI,eAAA;AA1CJ;;AA4CA;EACI;IACI,0BAAA;EAzCN;AACF;AA2CA;EACI,0BAAA;AAzCJ;;AA2CA;EACI,2BAAA;AAxCJ;;AA0CA;EACI,2BAAA;AAvCJ;;AAyCA;EACI,yBAAA;AAtCJ;;AAwCA;EACI,2BAAA;AArCJ;;AAwCA;EACI,2BAAA;AArCJ;;AAuCA;EACI,yBAAA;AApCJ;;AAsCA;EACI;IACI,0BAAA;EAnCN;AACF;AAqCA;EACI;IACI,0BAAA;EAnCN;AACF;AAqCA;EACI,WAAA;AAnCJ;;AAqCA;EACI,oBAAA;AAlCJ;;AAoCA;EACI,0BAAA;AAjCJ;;AAmCA;EACI,2BAAA;AAhCJ;;AAkCA;EACI,yBAAA;AA/BJ;;AAiCA;EACI,WAAA;EACA,gBAAA;AA9BJ;;AAgCA;EACI,0BAAA;AA7BJ;;AA+BA;EACI,2BAAA;AA5BJ;;AA8BA;EACI,2BAAA;AA3BJ;;AA6BA;EACI,0BAAA;AA1BJ;;AA6BA;EACI,yBAAA;AA1BJ","sourcesContent":[".payment-block {\n    background: #ffffff;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    padding: 16px;\n    font-family: Inter, system-ui, -apple-system, \"Segoe UI\", Roboto,\n        \"Helvetica Neue\", Arial;\n    color: #6b7280;\n    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04);\n    margin-top: 10px;\n    font-weight: 300;\n\n\n    .payment-header {\n        display: flex;\n        align-items: center;\n        margin-bottom: 12px;\n    }\n\n    .select-all {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        cursor: pointer;\n        user-select: none;\n\n\n        &-text {\n            font-weight: 600;\n            font-size: 14px;\n        }\n    }\n\n    .services-list {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n        margin-bottom: 14px;\n\n        .service-row {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: 10px;\n            border: 1px solid #ddd;\n            transition: background 0.12s;\n\n            &:hover {\n                background: #fbfdff;\n            }\n\n            .service-left {\n                display: flex;\n                align-items: center;\n                gap: 12px;\n                cursor: pointer;\n\n                input[type=\"checkbox\"] {\n                    width: 18px;\n                    height: 18px;\n                    accent-color: #666 !important;\n                }\n            }\n\n            .service-info {\n                display: flex;\n                flex-direction: column;\n                line-height: 1;\n\n                .service-sub {\n                    font-size: 10px;\n                    color: #6b7280;\n                    margin-bottom: 4px;\n                }\n            }\n\n            .service-price {\n                display: flex;\n                align-items: center; // Changed from baseline to center\n                justify-content: center; // Optional: centers horizontally if needed\n                font-weight: bold;\n                font-size: 14px;\n                color: #0f172a;\n                min-width: 90px;\n                text-align: right;\n\n                .price-dollars {\n                    font-size: 14px;\n                    color: #2e7d32;\n                    margin-right: 2px;\n                    line-height: 1;\n                }\n\n                .price-cents {\n                    font-size: 14px;\n                    color: #2e7d32;\n                    position: relative;\n                    top: -4px; // Raised slightly to mimic superscript\n                    line-height: 1;\n                }\n            }\n\n        }\n    }\n\n    .note {\n        font-size: 14px;\n        color: #666;\n        text-align: right;\n        margin-bottom: 4px;\n        white-space: normal !important;\n        word-break: normal !important;\n        overflow-wrap: break-word !important;\n        font-size: 10px !important;\n        margin-right: 0px !important;\n        display: flex;\n        justify-content: end !important;\n\n        .text {\n            max-width: 190px !important;\n        }\n    }\n\n    .total {\n        font-weight: bold;\n        color: #2e7d32;\n        font-size: 16px;\n    }\n\n    .total-row {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 8px;\n\n        .total-label {\n            color: #374151;\n        }\n\n        .total-value {\n            color: #666 !important;\n        }\n    }\n\n\n    .success-block {\n        margin-top: 24px;\n        padding: 16px;\n        border: 1px solid #d1fae5;\n        background-color: #ecfdf5;\n        border-radius: 8px;\n        text-align: center;\n        color: #065f46;\n\n        .success-title {\n            font-size: 18px;\n            font-weight: bold;\n            margin-bottom: 8px;\n            color: #059669;\n        }\n\n        .success-checkmark {\n            font-size: 32px;\n            color: #059669;\n            margin-bottom: 12px;\n        }\n    }\n}\n\n.success-block {\n    background: #f0fff4;\n    border: 2px solid #38a169;\n    border-radius: 12px;\n    padding: 2rem;\n    text-align: center;\n    max-width: 500px;\n    margin: 2rem auto;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n\n    .success-title {\n        font-size: 1.5rem;\n        font-weight: 700;\n        color: #2f855a;\n        margin-bottom: 1rem;\n    }\n\n    .success-checkmark {\n        font-size: 3rem;\n        color: #38a169;\n        margin: 1rem 0;\n        animation: pop 0.4s ease-in-out;\n    }\n\n    p {\n        font-size: 1rem;\n        color: #2d3748;\n        margin: 0.5rem 0;\n\n        strong {\n            color: #2f855a;\n        }\n    }\n}\n\n// simple animation for checkmark\n@keyframes pop {\n    0% {\n        transform: scale(0.5);\n        opacity: 0;\n    }\n\n    80% {\n        transform: scale(1.2);\n        opacity: 1;\n    }\n\n    100% {\n        transform: scale(1);\n    }\n}\n\n.plan-summary {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    font-size: 16px;\n    color: #333;\n\n    .plan-name {\n        font-weight: 600;\n    }\n\n    .payment-method {\n        font-weight: 500;\n\n        strong {\n            font-weight: 700;\n        }\n\n        span {\n            margin-left: 4px;\n            color: #666;\n        }\n    }\n}\n\n// paymentBlock.module.scss\n\n$radius: 8px;\n$font-size-lg: 1.125rem;\n$padding-vertical: 1.25rem;\n$padding-horizontal: 2rem;\n$gap: 1rem;\n$gray-bg: #e6e6e6;\n$gray-text: #222;\n$orange-bg: #ff8a00;\n$orange-text: #fff;\n$focus-outline: 0 0 0 3px rgba(0, 123, 255, 0.12);\n\n.row {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.col {\n    width: 100%;\n    max-width: 980px;\n    padding: 0 1rem;\n    display: flex;\n    justify-content: flex-start;\n    gap: $gap;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n/* Button base */\n.btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    border-radius: $radius;\n    font-weight: 600;\n    text-decoration: none;\n    cursor: pointer;\n    transition: transform 120ms ease, box-shadow 120ms ease;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.btnLarge {\n    font-size: $font-size-lg;\n    padding: $padding-vertical $padding-horizontal;\n}\n\n.btn:focus {\n    outline: none;\n    box-shadow: $focus-outline;\n    transform: translateY(-1px);\n}\n\n/* Gray link-like button */\n.btnGray {\n    background-color: $gray-bg;\n    color: $gray-text;\n    box-shadow: none;\n\n    &:hover {\n        filter: brightness(0.98);\n    }\n\n    &:active {\n        transform: translateY(0);\n    }\n}\n\n/* Orange primary button */\n.btnOrange {\n    background-color: $orange-bg;\n    color: $orange-text;\n    box-shadow: 0 6px 18px rgba(255, 138, 0, 0.18);\n\n    &:hover {\n        filter: brightness(0.97);\n    }\n\n    &:active {\n        transform: translateY(1px);\n    }\n}\n\n.printBtn {\n    order: 2;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n    .col {\n        justify-content: center;\n        gap: 0.5rem;\n    }\n\n    .btnLarge {\n        width: 100%;\n        padding: 0.9rem 1rem;\n        font-size: 1rem;\n    }\n\n    .printBtn {\n        order: 1;\n    }\n}\n\n\n// New\n\n.mb-20 {\n    margin-bottom: 20px !important;\n}\n.mr-10 {\n    margin-right: 10px !important;\n}\ninput[type=checkbox]:checked {\n    border-radius: 0;\n    background-image: url(../../public/images/check-white.png);\n    background-color: #666 !important;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: 60%;\n}\ninput[type=checkbox]:checked {\n    border-radius: 0;\n    background-image: url(../../public/images/check-white.png);\n    background-color: #666 !important;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: 60%;\n}\ninput[type=checkbox] {\n    width: 20px;\n    height: 20px;\n    border: 1px solid #666;\n    background-position: 50%;\n    background-size: 20px auto;\n    -webkit-appearance: none;\n}\n.mr-10 {\n    margin-right: 10px !important;\n}\n.mr-10 {\n    margin-right: 10px !important;\n}\n.select-all-check, .select-all-radio {\n    height: 25px !important;\n    min-height: 0 !important;\n    width: 25px !important;\n}\n\n.g-font-size-20, .gfs-20 {\n    font-size: 20px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.m-0 {\n    margin: 0 !important;\n}\n.g-font-size-20, .gfs-20 {\n    font-size: 20px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n .tru-mma-main-add,  .tru-mma-main-content-box,  .tru-mma-main-service-box {\n    border: 1px solid #6c757d;\n}\n@media (max-width: 768px) {\n    .tru-mma-main-content-box {\n        border: 0;\n        padding: 0 20px !important;\n    }\n}\n@media (min-width: 768px) {\n    .mb-md-0 {\n        margin-bottom: 0 !important;\n    }\n}\n.border-bottom {\n    border-bottom: 1px solid #6c757d !important;\n}\n.p-30 {\n    padding: 30px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n@media (min-width: 768px) {\n    .text-md-left {\n        text-align: left !important;\n    }\n}\n@media (min-width: 768px) {\n    .tru-mma-main-content-box .tru-mma-main-side {\n        border-left: 1px solid #6c757d !important;\n    }\n}\n@media (min-width: 992px) {\n    .text-lg-left {\n        text-align: left !important;\n    }\n}\n.bg-white {\n    background-color: #fff !important;\n}\n.p-10 {\n    padding: 10px !important;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-16, .gfs-lg-16 {\n        font-size: 16px !important;\n    }\n}\n.g-font-size-14, .gfs-14 {\n    font-size: 14px !important;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-16, .gfs-lg-16 {\n        font-size: 16px !important;\n    }\n}\n.g-font-size-14, .gfs-14 {\n    font-size: 14px;\n}\n@media (min-width: 768px) {\n    .g-font-size-md-40, .gfs-md-40 {\n        font-size: 40px !important;\n    }\n}\n.g-font-size-50, .gfs-50 {\n    font-size: 50px !important;\n}\n.g-font-weight-700, .gfw-7 {\n    font-weight: 700 !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n.text-green {\n    color: #73c573 !important;\n}\n.g-font-weight-700, .gfw-7 {\n    font-weight: 700 !important;\n}\n\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n.text-green {\n    color: #73c573 !important;\n}\n@media (min-width: 768px) {\n    .g-font-size-md-40, .gfs-md-40 {\n        font-size: 40px !important;\n    }\n}\n@media (min-width: 768px) {\n    .g-font-size-md-22, .gfs-md-22 {\n        font-size: 22px !important;\n    }\n}\nsup {\n    top: -.5em;\n}\n.m-0 {\n    margin: 0 !important;\n}\n.g-font-size-24, .gfs-24 {\n    font-size: 24px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.g-line-height-1, .glh-1 {\n    line-height: 1 !important;\n}\n.bg-white {\n    color: #666;\n    font-weight: 300;\n}\n.g-font-size-12, .gfs-12 {\n    font-size: 12px !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.g-font-size-26, .gfs-26 {\n    font-size: 26px !important;\n}\n\n.tg-ml-6 {\n    margin-left: 6 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"payment-block": `selectionBlock_payment-block__DuJ-H`,
	"payment-header": `selectionBlock_payment-header__5hzlX`,
	"select-all": `selectionBlock_select-all__Eutgg`,
	"select-all-text": `selectionBlock_select-all-text__XRL7B`,
	"services-list": `selectionBlock_services-list__+1+47`,
	"service-row": `selectionBlock_service-row__VIl5A`,
	"service-left": `selectionBlock_service-left__ZeYnr`,
	"service-info": `selectionBlock_service-info__szZ-e`,
	"service-sub": `selectionBlock_service-sub__cZ1hC`,
	"service-price": `selectionBlock_service-price__yZqTV`,
	"price-dollars": `selectionBlock_price-dollars__UzNL9`,
	"price-cents": `selectionBlock_price-cents__qNGTt`,
	"note": `selectionBlock_note__C8NeF`,
	"text": `selectionBlock_text__wSxG5`,
	"total": `selectionBlock_total__NaWL5`,
	"total-row": `selectionBlock_total-row__NQp3S`,
	"total-label": `selectionBlock_total-label__YNN3C`,
	"total-value": `selectionBlock_total-value__BlRJJ`,
	"success-block": `selectionBlock_success-block__p0iN3`,
	"success-title": `selectionBlock_success-title__XGqdZ`,
	"success-checkmark": `selectionBlock_success-checkmark__ZvKin`,
	"pop": `selectionBlock_pop__xgVpH`,
	"plan-summary": `selectionBlock_plan-summary__OwGVc`,
	"plan-name": `selectionBlock_plan-name__LqtRO`,
	"payment-method": `selectionBlock_payment-method__qbkWV`,
	"row": `selectionBlock_row__D-zEZ`,
	"col": `selectionBlock_col__tF-gw`,
	"btn": `selectionBlock_btn__4klLT`,
	"btnLarge": `selectionBlock_btnLarge__cNftO`,
	"btnGray": `selectionBlock_btnGray__2P3e1`,
	"btnOrange": `selectionBlock_btnOrange__5CjDe`,
	"printBtn": `selectionBlock_printBtn__V3K4f`,
	"mb-20": `selectionBlock_mb-20__Vw3iq`,
	"mr-10": `selectionBlock_mr-10__R424+`,
	"select-all-check": `selectionBlock_select-all-check__IO7aN`,
	"select-all-radio": `selectionBlock_select-all-radio__p6N71`,
	"g-font-size-20": `selectionBlock_g-font-size-20__cc5yY`,
	"gfs-20": `selectionBlock_gfs-20__hWdwo`,
	"g-font-weight-300": `selectionBlock_g-font-weight-300__V3dcW`,
	"gfw-3": `selectionBlock_gfw-3__5A82z`,
	"m-0": `selectionBlock_m-0__ReH-G`,
	"tru-mma-main-add": `selectionBlock_tru-mma-main-add__-a2gZ`,
	"tru-mma-main-content-box": `selectionBlock_tru-mma-main-content-box__HeYxx`,
	"tru-mma-main-service-box": `selectionBlock_tru-mma-main-service-box__JuPBB`,
	"mb-md-0": `selectionBlock_mb-md-0__czojD`,
	"border-bottom": `selectionBlock_border-bottom__fuNPv`,
	"p-30": `selectionBlock_p-30__hoZvg`,
	"text-md-left": `selectionBlock_text-md-left__iTsVt`,
	"tru-mma-main-side": `selectionBlock_tru-mma-main-side__1DO1v`,
	"text-lg-left": `selectionBlock_text-lg-left__V3J9s`,
	"bg-white": `selectionBlock_bg-white__9l9H+`,
	"p-10": `selectionBlock_p-10__TJJiY`,
	"g-font-size-lg-16": `selectionBlock_g-font-size-lg-16__cRpaw`,
	"gfs-lg-16": `selectionBlock_gfs-lg-16__Y56Th`,
	"g-font-size-14": `selectionBlock_g-font-size-14__jYEd1`,
	"gfs-14": `selectionBlock_gfs-14__BMBv0`,
	"g-font-size-md-40": `selectionBlock_g-font-size-md-40__z3WNL`,
	"gfs-md-40": `selectionBlock_gfs-md-40__nI0x8`,
	"g-font-size-50": `selectionBlock_g-font-size-50__SIzf4`,
	"gfs-50": `selectionBlock_gfs-50__zp+Vq`,
	"g-font-weight-700": `selectionBlock_g-font-weight-700__uOkFD`,
	"gfw-7": `selectionBlock_gfw-7__b6hk+`,
	"g-line-height-1_2": `selectionBlock_g-line-height-1_2__X+sMq`,
	"glh-1_2": `selectionBlock_glh-1_2__IirWd`,
	"text-green": `selectionBlock_text-green__lDYKZ`,
	"g-font-size-md-22": `selectionBlock_g-font-size-md-22__4G2X2`,
	"gfs-md-22": `selectionBlock_gfs-md-22__S2E0m`,
	"g-font-size-24": `selectionBlock_g-font-size-24__tmwC-`,
	"gfs-24": `selectionBlock_gfs-24__89tHS`,
	"g-line-height-1": `selectionBlock_g-line-height-1__dGrFX`,
	"glh-1": `selectionBlock_glh-1__2cZ0F`,
	"g-font-size-12": `selectionBlock_g-font-size-12__gBOOx`,
	"gfs-12": `selectionBlock_gfs-12__db-Qk`,
	"g-font-size-26": `selectionBlock_g-font-size-26__cVeZE`,
	"gfs-26": `selectionBlock_gfs-26__d93Xj`,
	"tg-ml-6": `selectionBlock_tg-ml-6__cVWDF`
};
export default ___CSS_LOADER_EXPORT___;
